import type { LinkHoverPrefetchProps } from '@pearlconvert/ui/components/link/link-hover-prefetch.types'

import React, { useCallback, useState } from 'react'

export const useLinkHoverPrefetch = (
  onMouseEnter: LinkHoverPrefetchProps['onMouseEnter']
) => {
  const [hovered, setHovered] = useState(false)

  const handleMouseEnter = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      setHovered(true)
      onMouseEnter?.(e)
    },
    [onMouseEnter]
  )

  return {
    hovered,
    handleMouseEnter,
  }
}
